import React from "react";
import Chart from "react-apexcharts";

const CaloriesChart = ({ from, to }) => {
    const percentage = Math.min((from / to) * 100, 100)?.toFixed(0);

    const options = {
        chart: {
            type: "radialBar",
        },
        plotOptions: {
            radialBar: {
                hollow: { size: "55%" },
                track: { background: "#D9D9D9" },
                dataLabels: {
                    name: { show: false },
                    value: { color: "#fff", fontSize: "16px", fontWeight: "bold", offsetY: 5 },
                },
            },
        },
        colors: ["#06BCC1"],
    };

    const series = [percentage ? percentage : 75];

    return (
        <div className="text-white text-center flex items-center justify-center">
            <Chart options={options} series={series} type="radialBar" width={110} height={125} />
        </div>
    );
};

export default CaloriesChart;
